export default __webpack_public_path__ + "static/media/up-arr-yell.80215626.svg";